import { render, staticRenderFns } from "./MoleculeAnchorV2.vue?vue&type=template&id=b9cf1cc6&"
import script from "./MoleculeAnchorV2.vue?vue&type=script&lang=js&"
export * from "./MoleculeAnchorV2.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeAnchorV2.vue?vue&type=style&index=0&id=b9cf1cc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports